/// <amd-module name="SuiteCommerce.Blog.PostSearch.View"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.Blog.PostSearch.View", ["require", "exports", "Backbone", "sc_blog_post_search.tpl", "SuiteCommerce.Blog.PostSearch.Configuration", "SuiteCommerce.Blog.Common", "SuiteCommerce.Blog.Common.ParameterProcessor", "SuiteCommerce.Blog.PostList.View", "SuiteCommerce.Blog.PostList.Model", "SuiteCommerce.Blog.PostCard.View", "SuiteCommerce.Blog.Common.Searcher.Helper", "SuiteCommerce.Blog.Post.Collection", "SuiteCommerce.Blog.Pagination.View", "SuiteCommerce.Blog.Pagination.Model", "SuiteCommerce.Blog.SuggestionsList.View", "SuiteCommerce.Blog.SuggestionsList.Model", "SuiteCommerce.Blog.DataProvider"], function (require, exports, Backbone_1, postSearchTemplate, PostSearch_Configuration_1, Common_1, ParameterProcessor_1, PostList_View_1, PostList_Model_1, PostCard_View_1, BlogPostSearcher_Helper_1, Post_Collection_1, Pagination_View_1, Pagination_Model_1, SuggestionsList_View_1, SuggestionsList_Model_1, DataProvider_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.PostSearchView = void 0;
    var PostSearchView = /** @class */ (function (_super) {
        __extends(PostSearchView, _super);
        function PostSearchView(options) {
            var _this = _super.call(this, options) || this;
            _this.template = postSearchTemplate;
            _this.isExpandedLayout = false;
            _this.pageSize = 5;
            _this.defaultPage = 1;
            _this.paginationEventName = 'triggered-pagination-mobile-search';
            _this.currentPage = _this.defaultPage;
            _this.events = {
                'keyup [data-action="search-for-phrase"]': 'searchForPhrase',
                'click [data-action="close-search"]': 'closeSearch',
                'click [data-action="scroll-to-top"]': 'scrollToTop',
            };
            _this.setupResultListView();
            _this.setupPagination();
            _this.suggestionsView = new SuggestionsList_View_1.SuggestionsListView({
                model: new SuggestionsList_Model_1.SuggestionsListModel(),
            });
            _this.paginationView.on(_this.paginationEventName, function (data) {
                _this.scrollToTop();
                if (_this.resultListView.model.posts.size() > 0)
                    _this.resetSearch();
                _this.currentPage = data.page;
                _this.fetchPostByPhrase();
            });
            return _this;
        }
        PostSearchView.prototype.setupResultListView = function () {
            this.resultListView = new PostList_View_1.PostListView({
                model: new PostList_Model_1.PostListModel({
                    postCardLayout: PostCard_View_1.PostCardLayout.horizontal,
                    posts: new Post_Collection_1.PostCollection(),
                    showPostCardsPlaceholders: true,
                    postCardPlaceholdersQuantity: 5,
                }),
            });
        };
        PostSearchView.prototype.setupPagination = function () {
            this.paginationView = new Pagination_View_1.PaginationView({
                model: new Pagination_Model_1.PaginationModel({
                    pageSize: this.pageSize,
                    total: 0,
                    currentPage: this.defaultPage,
                    isEnabledEventsHandling: true,
                    paginationEventId: this.paginationEventName,
                }),
            });
        };
        PostSearchView.prototype.searchForPhrase = function (event) {
            this.model.phrase = event.target.value ? event.target.value.trim() : '';
            if (event.key === 'Enter' && this.model.phrase.length > 0) {
                if (this.isMobileDevice()) {
                    if (!this.isExpandedLayout)
                        this.expandLayout();
                    if (this.resultListView.model.posts.size() > 0 ||
                        this.suggestionsView.model.suggestionList.size() > 0) {
                        this.resetSearch();
                    }
                    this.$el.find('.sc-blog-post-search-form-input').trigger('blur');
                    this.fetchPostByPhrase();
                }
                else {
                    var URIComponent = encodeURIComponent(this.model.phrase);
                    Backbone_1.history.navigate(Common_1.BLOG_URL_BASE + "?" + ParameterProcessor_1.SearchPhraseSettings.keywords + "=" + URIComponent, true);
                }
            }
        };
        PostSearchView.prototype.isMobileDevice = function () {
            var viewportWidth = jQuery(window).width();
            return viewportWidth < 768;
        };
        PostSearchView.prototype.expandLayout = function () {
            this.$el
                .children('.sc-blog-post-search')
                .addClass('expanded-search-layout');
            jQuery('body').addClass('expanded-search-layout');
            this.hideScrollBar();
        };
        PostSearchView.prototype.hideScrollBar = function () {
            jQuery('.sc-blog-post-list-container').css('scrollbar-width', 'none');
        };
        PostSearchView.prototype.resetSearch = function () {
            this.suggestionsView.model.searchOptions = null;
            this.suggestionsView.render();
            this.resultListView.model.highlightInCards = this.model.phrase;
            this.resultListView.model.posts = new Post_Collection_1.PostCollection();
            this.resultListView.model.showPostCardsPlaceholders = true;
            this.paginationView.model.total = 0;
            this.currentPage = this.defaultPage;
            this.paginationView.generateButtons();
            this.resultListView.render();
            var $scrollTopLink = this.$el.find('.sc-blog-post-search-footer-back-to-top-link');
            if (!$scrollTopLink.hasClass('hide')) {
                $scrollTopLink.addClass('hide');
            }
        };
        PostSearchView.prototype.scrollToTop = function () {
            this.$el.find('.sc-blog-post-search').animate({ scrollTop: '0' });
        };
        PostSearchView.prototype.fetchPostByPhrase = function () {
            var _this = this;
            this.resultListView.model.posts
                .fetch(BlogPostSearcher_Helper_1.BlogPostSearcherHelper.buildRequestBody({
                taxonomies: [],
                settings: { pageNumber: this.currentPage, pageSize: this.pageSize },
                searchPhrase: Common_1.sanitizeString(this.model.phrase),
            }))
                .done(function () {
                _this.resultListView.model.showPostCardsPlaceholders = false;
                _this.paginationView.model.total = _this.resultListView.model.posts.totalInServer;
                _this.paginationView.model.currentPage = _this.currentPage;
                _this.paginationView.generateButtons();
                _this.resultListView.render();
                if (_this.resultListView.model.posts.size() === 0) {
                    if (DataProvider_1.DataProvider.entitiesModel.isSync) {
                        _this.setupSuggestionsListView();
                    }
                    else {
                        DataProvider_1.DataProvider.entitiesModel.on('change:isSync', function () {
                            _this.setupSuggestionsListView();
                        });
                    }
                }
                _this.addScrollToTopLink();
            });
        };
        PostSearchView.prototype.setupSuggestionsListView = function () {
            var _this = this;
            var pinnedTaxonomies = [];
            var searchTerm = DataProvider_1.DataProvider.terms.getTermByURLComponent(Common_1.DefaultTaxonomies.search.defaultAlias);
            if (searchTerm && searchTerm.isUsed) {
                pinnedTaxonomies.push({
                    name: Common_1.AvailableTaxonomies.term,
                    value: searchTerm.urlComponent,
                });
            }
            (this.suggestionsView.model.title = PostSearch_Configuration_1.PostSearchConfiguration.noSearchResultsLabel.replace('[[term]]', "<span class=\"term\">" + this.model.phrase + "</span>")),
                (this.suggestionsView.model.suggestionMessage =
                    PostSearch_Configuration_1.PostSearchConfiguration.noResultsArticleSuggestionMessage);
            this.suggestionsView.model.searchOptions = {
                settings: { pageSize: 5, pageNumber: 1 },
                taxonomies: pinnedTaxonomies,
            };
            this.suggestionsView.model.quantityOfSuggestions = 2;
            this.suggestionsView
                .fetchSuggestionList()
                .done(function () { return _this.addScrollToTopLink(); });
        };
        PostSearchView.prototype.addScrollToTopLink = function () {
            var $scrollTopLink = this.$el.find('.sc-blog-post-search-footer-back-to-top-link');
            if (this.thereIsOverflowedContent() && $scrollTopLink.hasClass('hide')) {
                $scrollTopLink.removeClass('hide');
            }
            else {
                $scrollTopLink.addClass('hide');
            }
        };
        PostSearchView.prototype.thereIsOverflowedContent = function () {
            var contentHeight = this.$el.find('.sc-blog-post-search-results').height() +
                this.$el.find('.sc-blog-post-search-form').height() +
                this.$el.find('.sc-blog-post-search-title').height() +
                this.$el.find('.sc-blog-suggestions').height();
            return contentHeight > jQuery(window).height();
        };
        PostSearchView.prototype.closeSearch = function () {
            this.contractLayout();
            this.model.phrase = '';
            this.resetSearch();
            this.render();
        };
        PostSearchView.prototype.contractLayout = function () {
            this.$el
                .children('.sc-blog-post-search')
                .removeClass('expanded-search-layout');
            jQuery('body').removeClass('expanded-search-layout');
            this.showScrollBar();
        };
        PostSearchView.prototype.showScrollBar = function () {
            jQuery('.sc-blog-post-list-container').css('scrollbar-width', 'auto');
        };
        Object.defineProperty(PostSearchView.prototype, "childViews", {
            get: function () {
                var _this = this;
                return {
                    'SearchResults.View': function () {
                        return _this.resultListView;
                    },
                    'Pagination.View': function () {
                        return _this.paginationView;
                    },
                    'Suggestions.View': function () {
                        return _this.suggestionsView;
                    },
                };
            },
            enumerable: false,
            configurable: true
        });
        PostSearchView.prototype.getContext = function () {
            return {
                searchHint: PostSearch_Configuration_1.PostSearchConfiguration.searchHint,
                searchLabel: PostSearch_Configuration_1.PostSearchConfiguration.searchLabel,
                defaultText: this.model.phrase,
                closeButtonLabel: PostSearch_Configuration_1.PostSearchConfiguration.searchCloseButtonLabel,
                backToTopLabel: PostSearch_Configuration_1.PostSearchConfiguration.backToTopLabel,
            };
        };
        PostSearchView.prototype.destroy = function () {
            jQuery('body').removeClass('expanded-search-layout');
        };
        return PostSearchView;
    }(Backbone_1.View));
    exports.PostSearchView = PostSearchView;
});
